import { render, staticRenderFns } from "./OnboardingView.vue?vue&type=template&id=0374b9cf&scoped=true&"
import script from "./OnboardingView.vue?vue&type=script&lang=js&"
export * from "./OnboardingView.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingView.vue?vue&type=style&index=0&id=0374b9cf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0374b9cf",
  null
  
)

export default component.exports